import React from 'react';
import { Box, Chip, Typography } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { COMPANY_TYPE_FILTERS, getCompanyTypeChipSx } from '../../utils/companyHelpers';

const CompanyTypeFilter = ({
  selectedTypes,
  onChange,
  size = 'small',
  label = 'Filter',
  sx = {},
}) => {
  const theme = useTheme();

  const handleToggle = (typeId) => {
    const nextTypes = selectedTypes.includes(typeId)
      ? selectedTypes.filter((id) => id !== typeId)
      : [...selectedTypes, typeId];

    if (!nextTypes.length) return;
    onChange(nextTypes);
  };

  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        gap: 0.5,
        flexWrap: 'nowrap',
        overflowX: 'auto',
        ...sx,
      }}
      aria-label="Company type filter"
    >
      {label && (
        <Typography
          variant="caption"
          sx={{
            color: 'text.secondary',
            fontWeight: 600,
            lineHeight: 1,
            whiteSpace: 'nowrap',
            mr: 0.25,
          }}
        >
          {label}
        </Typography>
      )}
      {COMPANY_TYPE_FILTERS.map((type) => {
        const selected = selectedTypes.includes(type.id);
        return (
          <Chip
            key={type.id}
            size={size}
            label={type.label}
            variant={selected ? 'filled' : 'outlined'}
            onClick={() => handleToggle(type.id)}
            aria-pressed={selected}
            sx={{
              ...getCompanyTypeChipSx(type.id, selected, theme),
              height: size === 'small' ? 20 : 24,
              fontSize: size === 'small' ? '10.5px' : '11.5px',
              fontWeight: selected ? 600 : 500,
              flexShrink: 0,
              '& .MuiChip-label': {
                px: size === 'small' ? 0.65 : 0.85,
              },
            }}
          />
        );
      })}
    </Box>
  );
};

export default CompanyTypeFilter;
